import type { FaireProductEntity } from "../../entity_types/product";

export const p_pk5n43tn2s: FaireProductEntity = {
  token: "p_pk5n43tn2s",
  type: "product",
  name: "Ginger Ale",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/311e0c97a29366fa849e2f1f34b3f15dadcf968188919861c9ab6c5fc84c1c6a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb2d861c3d9e0ff87115ed6eac200b2e4b76a51560f53486c9a94b894491b65e.png",
    "https://cdn.faire.com/fastly/bac8dc7501be7a8a3836af3bcbd53c304a738b0656ef8780a08228a5899597fc.png",
    "https://cdn.faire.com/fastly/9666ea1f2b630d68ad70a8fdbcf32a9810f6b812623114c8062047bc8cab617b.png",
    "https://cdn.faire.com/fastly/b840b39df6306bfef9131f963036feb459359e2c6d33be50267685f5b6bfa0b4.png",
    "https://cdn.faire.com/fastly/6bd4d7d1c0d678324e2036d00d4bc40a8989413cbbb0265b8c0b983116efe3e7.png",
  ],
  priceDollars: 28.99,
  description:
    "Pinkies Up! Sweet lime, tart quince, and real ginger root help create a uniquely refreshing yet nostalgic Ginger Ale flavor that will make you feel oh so sophisticated.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:13.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
